import { config } from '../../constants'
export class SquidexAuth {
  async getToken(): Promise<string> {
    try {
      const tokenResponse = await fetch('https://cloud.squidex.io/identity-server/connect/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `grant_type=client_credentials&client_id=${encodeURIComponent(config.squidex.clientId)}&client_secret=${encodeURIComponent(
          config.squidex.clientSecret
        )}&scope=squidex-api`,
      })
      const tokenData = await tokenResponse.json()
      const accessToken = tokenData.access_token
      return accessToken
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
